<template>
  <ion-col>
    <div class="legal allow-select">
      <section ref="copyright-notice">
        <h5>Copyright Notice</h5>
        <p>Copyright © 2016 – {{new Date().getFullYear()}}, <b>AppSmart Inc.</b>. All Rights Reserved.</p>
      </section>
      <hr/>
    <section ref="disclaimer">
        <h5>Disclaimer</h5>
        <p><b>Lawyerly</b> is project primarily designed to assist students of law in their studies. It is merely a tool. The use of our Services does not guarantee success in obtaining a law degree nor in passing the Bar Exams. <b>AppSmart Inc.</b> makes no warranties or representations of any kind, whether expressed or implied for the Services provided.</p>
        <p>
        The cases, laws, and other publications found in this site are of public domain, collected from public sources such as the Supreme Court online library. The content however have been heavily modified, formatted, and optimized for better user experience, and are no longer perfect copies of their original. <b>AppSmart Inc.</b> gives no warranty for the accuracy or the completeness of the materials. <b>AppSmart Inc.</b> also reserves the right to further improve, add, modify, or remove content with or without prior announcements.
        </p>

        <p>
        This site also contains materials published by the students, professors, lawyers, and other users of the our Services. These materials are owned by such users and of their sole responsibility. While we may review user-published content, please do not assume that content you are accessing has been reviewed or curated. You may report abusive content through the listed contact details.
        </p>

        <p>
        <b>AppSmart Inc.</b> does not guarantee against any loss or damage caused by third persons, delays, interruptions, unavailability, or by the termination of its Services.
        </p>

        <p>
        <b>AppSmart Inc.</b> reserves the right to amend the terms and policies for its Services.
        </p>
    </section>
    <hr/>
    <section ref="term-of-service">
        <h5>Terms of Service</h5>
        <p>
        By using our Services, you are agreeing to these terms. Please read them carefully. 
        </p>

        <p>
        Access our Services only through the interface and instructions provided. Do not misuse the Services, or use them in such ways that may interfere their availability, or in ways that may cause discredit to you, your school, or your profession.
        </p>

        <p>
        These terms do not give you ownership of any intellectual property rights to the content you access on our Services. Do not use content from our Services other than for personal purposes unless you obtain permission from its owner or are otherwise permitted by law. Do not remove, obscure, or alter any legal notices and attributions displayed in or along with our Services.
        </p>

        <p>
        We may send you service announcements, administrative messages, and other information. You may opt out of some of those communications.
        </p>

        <p>
        Our Services are designed to be accessible on mobile devices. Do not use such Services in a way that distracts you and prevents you from obeying traffic or safety laws.
        </p>

        <p>
        We may suspend or stop providing our Services to you if you do not comply with these terms and policies or if we are investigating suspected misconduct.
        </p>
    </section>
    <hr/>
    <section ref="privacy">
        <h5>Privacy</h5>

        <p>
        Some services require you to login or register with minimal personal information this site. 
        </p>

        <p><em>Collected Information</em></p>
        <p>Collected information includes user name, email address, Facebook ID and photo. The user may also optionally provide school, year level, BAR year, profession, office, address, and other information which may assist in improving our Services.</p>

        <p><em>Uses of the Information</em></p>
        <p>The collected information will only be used in connection with the use or for the improvement of our Services.</p>

        <p><em>Users Created Content</em></p>
        <p>Content created by users are published and shared for public use. Published content is always attributed to the author through his user account. A user may remain anonymous by changing his "display name" under his profile.</p>

        <p><em>Data Analytics</em></p>
        <p>
        <b>AppSmart Inc.</b> conducts data analytics for the improvement of the usability and design of our Services and the user experience. These may include but not limited to tracking time spent on the site, services availed, number of contents created or shared.
        </p>
    </section>
    <hr/>
    <section ref="content-policy">
        <h5>Content Policy</h5>

        <p>
        Our Services allow you to create casebooks, digests, outlines, notes, and other content. You retain ownership of intellectual property rights that you hold in that content.
        </p>

        <p>
        When you create content through our Services, you give <b>AppSmart Inc.</b> (and those we work with) a worldwide license to use, host, store, reproduce, modify, create derivative works, communicate, publish, publicly perform, publicly display and distribute such content. This license continues even if you stop using our Services (for example: your list of cases, digests, and outlines in your casebooks).
        </p>

        <p>
        Make sure you have the necessary rights to grant us this license for any content that you submit to our Services.
        </p>

        <p><b>AppSmart Inc.</b> reserves the right to review your published content and may remove materials that are offensive, abusive, of no value, or not in line with the purpose of our Services. The amount of content or materials that you publish may be limited by us.
        </p>
    </section>
    <hr/>
    <section ref="contact-us">
        <h5>Contact Us</h5>

        <p>Reach us through our facebook page <a href="https://fb.me/lawyerly.ph">http://fb.me/lawyerly.ph</a>.</p>
        <br/>
        <p>Lawyerly.ph is managed by <b>Bitesize Digital Group, Inc</b>.</p>
    </section>
    </div>
  </ion-col>
</template>
<script>
export default {
  watch: {
    "$route.query.to": function(n, o) {
      this.$nextTick(function() {
        //console.log(n);
        //console.log(o);
        if(n) {
          if(n !== 0) {
            this.scrollTo(n);
          }
        }
      });
    }
  },
  methods: {
    scrollTo(id) {
      //console.log("scroll to: " + id);
      this.$refs[id].scrollIntoView({
        block: 'start',
        behavior: "smooth"
      });
    }
  },
  mounted() {
    if(this.$route.query) {
      if(this.$route.query.to) {
        setTimeout(()=>{
          this.scrollTo(this.$route.query.to);
        }, 160);
      }
    }
  }
};
</script>
<style scoped>
  .legal section {
    padding: 1em 0;
  }
  .legal section h5 {
    color: var(--ion-color-primary);
    font-weight: 500;
    margin: 0;
  }
</style>
